import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment.prod';
import { HttpClient } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class PartsService {

  constructor(private http: HttpClient) {}



  get(page: number = 1, perPage: number = 50, categoryId: string = '', search: string = '') {
    let url = `${environment.apiUrl}admin/get/parts?page=${page}&per_page=${perPage}`;

    if (categoryId) {
      url += `&category_id=${encodeURIComponent(categoryId)}`;
    }

    const q = (search || '').toString().trim();
    if (q) {
      url += `&search=${encodeURIComponent(q)}`;
    }

    return this.http.get(url);
  }



  create(data: any) {
    return this.http.post(environment.apiUrl +  'admin/part/add', data);
  }

  update(id: number, data: any) {
    return this.http.post(environment.apiUrl +  'admin/part/update/' + id ,data);
  }

  delete(id: number) {
    return this.http.delete(environment.apiUrl +  `admin/part/destroy/${id}`);
  }

  updatePositions(items: any[]) {
    return this.http.post(environment.apiUrl +  'admin/part/update-positions', items);
  }

}
